import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RdpClientComponent } from './rdp-client.component';

import { NzCardModule } from 'ng-zorro-antd/card';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzSegmentedModule } from 'ng-zorro-antd/segmented';

@NgModule({
  declarations: [
    RdpClientComponent
  ],
  imports: [
    CommonModule,
    FormsModule,

    // Ng-Zorro modules
    NzCardModule,
    NzButtonModule,
    NzRadioModule,
    NzDescriptionsModule,
    NzCollapseModule,
    NzAlertModule,
    NzTagModule,
    NzIconModule,
    NzEmptyModule,
    NzSegmentedModule
  ],
  exports: [
    RdpClientComponent
  ]
})
export class RdpClientModule { }